<template>
  <div id="footbar">
    <div style="font-size:12px; padding:5px; color:#8a6d3b;">
      USD(네이버) {{ usd_naver }} 원&nbsp;&nbsp;&nbsp;USD-USDT {{usdt}}
      <br />카카오톡 오픈 1:1 채팅
      <a
        href="https://open.kakao.com/o/sxDY2aL"
        target="_blank"
        class="link"
      >https://open.kakao.com/o/sxDY2aL</a>
      <br />바이낸스는 USDT, 비트파이넥스는 USD 입니다.
      <br />바이낸스KRW = 바이낸스BTC*업비트BTC (24hr=UTCTIME기준)
      <br />안드로이드앱: 플레이스토어 wisebody 검색 부탁드려요.
      <br />제 홈페이지 이용해주셔서 항상 감사드립니다.
      <br />
    </div>
    <div style="text-align:center; font-size:13px; color:#999999; padding:10px 0;">
      본 페이지는 참고용으로만 사용해주세요.
      <br />e-mail : lee@wisebody.co.kr
      <br />
      <br />
      <br />
      <br />
    </div>
    <div class="divBottom">
      <el-button
        plain
        size="mini"
        icon="el-icon-refresh"
        class="divBottomButton"
        @click="fetchData"
      >새로고침</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footbar',
  data () {
    return {
      usd_naver: '',
      usdt: ''
    }
  },
  methods: {
    fetchData () {
      this.$root.$refs.M.fetchData()
    }
  },
  created () {
    this.$root.$refs.F = this
  }
}
</script>

<style scoped>
.divBottom {
  text-align: center;
}
.divBottomButton {
  position: fixed;
  bottom: 10px;
  margin-left: -40px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue